import React, { useMemo } from 'react'
import './FlatButton.css'
import './InputDeviceDropdown.css'

interface InputDeviceDropdownProps {
  labelTop?: string
  selectedDeviceId: string
  audioDevices: MediaDeviceInfo[]
  disabled?: boolean
  onChange: (deviceId: string) => void
}

const InputDeviceDropdown: React.FC<InputDeviceDropdownProps> = ({
  selectedDeviceId,
  audioDevices,
  disabled = false,
  onChange,
}) => {
  const selectedLabel = useMemo(() => {
    const found = audioDevices.find((d) => d.deviceId === selectedDeviceId)
    if (!found) return 'Select input'
    return found.label || `Input ${found.deviceId.slice(0, 8)}`
  }, [audioDevices, selectedDeviceId])

  return (
    <div className="control-unit input-select-unit">
      <div className="input-select-row">
        {/* Housing (div instead of button so we can place a real <select> inside) */}
        <div
          className={`hw-btn-housing input-select-housing ${disabled ? 'disabled' : ''}`}
        >
          <div className="hw-btn-inner">
            <div className="hw-btn-face input-select-face">
              <div className="input-select-value" aria-hidden="true">
                {selectedLabel}
              </div>
              <div className="input-select-chevron" aria-hidden="true">
                ▾
              </div>
              <select
                className="input-device-native-select"
                value={selectedDeviceId}
                onChange={(e) => onChange(e.target.value)}
                disabled={disabled}
                aria-label="Input device"
              >
                {audioDevices.map((device) => (
                  <option key={device.deviceId} value={device.deviceId}>
                    {device.label || `Input ${device.deviceId.slice(0, 8)}`}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      <div className="input-select-led-row">
        <div
          className={`input-select-led ${disabled ? 'ready' : 'blocked'}`}
          aria-hidden="true"
        />
      </div>
    </div>
  )
}

export default InputDeviceDropdown
